package kz.dentalcrm.app.screens.quick_replies.add

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_quick_reply_added
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.QuickRepliesRepository
import kz.dentalcrm.app.screens.quick_replies.add.mvi.AddQuickReplyViewEvent
import kz.dentalcrm.app.screens.quick_replies.add.mvi.AddQuickReplyViewSideEffect
import kz.dentalcrm.app.screens.quick_replies.add.mvi.AddQuickReplyViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class AddQuickReplyViewModel :
    BaseStateViewModel<AddQuickReplyViewEvent, AddQuickReplyViewState, AddQuickReplyViewSideEffect>() {

    private val quickRepliesRepository: QuickRepliesRepository by inject()

    override fun setInitialState() = AddQuickReplyViewState()

    override fun handleEvents(event: AddQuickReplyViewEvent) {
        when (event) {
            is AddQuickReplyViewEvent.AddQuickReply -> addQuickReply(event.message)
            AddQuickReplyViewEvent.Reset -> setState { copy(screenState = AddQuickReplyViewState.ScreenState.Idle) }
        }
    }

    private fun addQuickReply(message: String) {
        setState { copy(screenState = AddQuickReplyViewState.ScreenState.Adding) }
        launch(Dispatchers.Default) {
            when (val result = quickRepliesRepository.addQuickReply(message = message)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_quick_reply_added), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = AddQuickReplyViewState.ScreenState.Added) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState { copy(screenState = AddQuickReplyViewState.ScreenState.Error(error = result.message ?: "Неизвестная ошибка")) }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState { copy(screenState = AddQuickReplyViewState.ScreenState.Error(error = "Неизвестная ошибка")) }
                }
            }
        }
    }

    override fun onCleared() {
        setState { AddQuickReplyViewState() }
    }
}
